/* eslint-disable react/jsx-key */
import { Box, Button, Divider, Drawer, Typography } from '@mui/material';
import { useState } from 'react';
import MobileDrawerToggle from '../../../../components/MobileDrawerToggle/MobileDrawerToggle';
import StepperProps from '../../lib/StepperProps';

/**
 * The client onboarding stepper for small screens
 */
const NarrowStepper = (props: StepperProps) => {
  const [showMobileNav, setShowMobileNav] = useState(false);

  return (
    <Box display="flex" height="100%" flexDirection="column">
      <Box height="100%" overflow="auto" display="flex" flexDirection="column">
        {props.steps.length > 0 && props.showTitle && (
          <Typography
            component="h1"
            textAlign="center"
            fontSize="2.5em"
            marginTop=".75em"
            fontWeight="600"
          >
            {props.steps[props.activeStep].stepTitle}
          </Typography>
        )}
        <Box
          display="flex"
          height="100%"
          flexDirection="column"
          padding=".25em"
        >
          <Box height="100%">
            {props.steps.length > 0
              ? props.steps[props.activeStep].stepContent
              : ''}
          </Box>
        </Box>
      </Box>
      <Divider />
      <MobileDrawerToggle
        drawerState="hidden"
        setShowNav={() => setShowMobileNav(true)}
      />
      <Drawer
        anchor="bottom"
        open={showMobileNav}
        onClick={() => setShowMobileNav(false)}
        sx={{
          zIndex: 1500,
        }}
      >
        <Box padding="1em" display="flex" flexDirection="column" gap="1em">
          {props.steps.map((s, i) => (
            <Button
              key={i}
              color="secondary"
              sx={{
                fontSize: '2em',
                border: props.activeStep == i ? '1px solid' : 'initial',
              }}
              onClick={() => props.setActiveStep(i)}
              disabled={i > props.latestStep}
            >
              {s.stepTitle}
            </Button>
          ))}
        </Box>
        <MobileDrawerToggle
          drawerState="showing"
          setShowNav={() => setShowMobileNav(false)}
        />
      </Drawer>
    </Box>
  );
};

export default NarrowStepper;
